import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { useCreateMailpiecesListCommentMutation, useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';
import useNotifyComment from './NotifyComment/useNotifyComment';
import NotifyMairoomComment from './NotifyComment';

export const FinishShred = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces] = useUpdatePiecesMutation();

  const [createMailpiecesListComment] = useCreateMailpiecesListCommentMutation();

  const [actionInProgress, setActionInProgress] = useState<boolean>(false);

  const { values, changeValues } = useNotifyComment();

  const confirmAction = async () => {
    try {
      setActionInProgress(true);

      await updatePieces({
        pieces: mailpieces.map((piece) => ({ id: piece.id })),
        action: PieceAction.FinishShred,
        shouldNotifyRecipient: !values.skipNotifyRecipient,
      }).unwrap();

      const comment = values.comment.trim();

      if (comment.length) {
        await createMailpiecesListComment({
          text: comment,
          notifyMailroom: values.notifyMailroom,
          pieceIds: mailpieces.map((piece) => piece.id),
        }).unwrap();
      }

      setActionInProgress(false);
      onActionFinish();
    } catch (error) {
      setActionInProgress(false);
    }
  };

  const content = (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {mailpieces.length === 1 ? (
          "Please shred this item, and click Complete when you're done."
        ) : (
          <>
            Please shred <strong>{mailpieces.length}</strong> item(s), and click Complete when you&apos;re done.
          </>
        )}
      </Typography>

      <NotifyMairoomComment values={values} onChange={changeValues} />
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={actionInProgress}
      maxWidth="sm"
      title={mailpieces.length === 1 ? 'Shred item' : 'Shred selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Complete"
      cancelButtonTitle="Cancel"
    />
  );
};
